import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/Icons/accordeon-toggle.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-cf1a37dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bank_account" }
const _hoisted_2 = { class: "support_container" }
const _hoisted_3 = { class: "support_top_infobox" }
const _hoisted_4 = { class: "support_contacts" }
const _hoisted_5 = { class: "info_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "tel:+420228880237",
  class: "contact_btn"
}, "+420 228 880 237", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "info_item" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "support_categories_container" }
const _hoisted_11 = { class: "support_categories_box" }
const _hoisted_12 = { class: "category_list" }
const _hoisted_13 = { class: "arrow" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub_line" }, null, -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "support_question_box"
}
const _hoisted_17 = { class: "question_list_box" }
const _hoisted_18 = { class: "question_list" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "support_one_question_box"
}
const _hoisted_21 = { class: "breadcrumbs_box" }
const _hoisted_22 = { class: "breadcrumbs" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aba_button_right = _resolveComponent("aba-button-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("MondayToFriday")) + " ", 1),
              _hoisted_7,
              _createTextVNode("08:00 – 17:00 CET / 07:00 – 16:00 GMT ")
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              href: 'mailto:support@' + _ctx.domain,
              class: "contact_btn"
            }, "support@" + _toDisplayString(_ctx.domain), 9, _hoisted_9),
            _createElementVNode("p", null, _toDisplayString(_ctx.$localization.getTranslate("Anytime")), 1)
          ])
        ]),
        _createVNode(_component_aba_button_right, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage('contactBank')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("MessageToBank")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$localization.getTranslate("Categories")), 1),
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "category_item",
                key: item.Id
              }, [
                _createElementVNode("a", {
                  class: "open_sub",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenSelectCategory = !_ctx.isOpenSelectCategory))
                }, [
                  _createElementVNode("p", null, _toDisplayString(item.Name), 1),
                  _createElementVNode("span", _hoisted_13, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "arrow",
                      style: _normalizeStyle({
											transform: `rotate(${_ctx.isOpenSelectCategory ? '0' : '180deg'})`,
										})
                    }, null, 4)
                  ])
                ]),
                _hoisted_14,
                _createElementVNode("ul", {
                  class: "sub_items",
                  style: _normalizeStyle(_ctx.isVisibleBlock(_ctx.isOpenSelectCategory))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Children, (child) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: child.Id
                    }, [
                      _createElementVNode("a", {
                        class: "pointer",
                        onClick: ($event: any) => (_ctx.SelectCategory(child))
                      }, _toDisplayString(child.Name), 9, _hoisted_15)
                    ]))
                  }), 128))
                ], 4)
              ]))
            }), 128))
          ])
        ]),
        (!_ctx.isActiveCategory && !_ctx.isActiveQuestion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$localization.getTranslate("PopularQuestions")), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("ul", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PopularQuestions, (item) => {
                    return (_openBlock(), _createElementBlock("li", { key: item }, [
                      _createElementVNode("a", {
                        class: "pointer",
                        onClick: ($event: any) => (_ctx.SelectQuestion(item))
                      }, _toDisplayString(item.Name), 9, _hoisted_19)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isActiveQuestion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("ul", _hoisted_22, [
                  (_ctx.SelectedCategory?.Name)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, _toDisplayString(_ctx.SelectedCategory.Name), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", null, _toDisplayString(_ctx.SelectedQuestion?.Name), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: "one_question_container",
                innerHTML: _ctx.SelectedQuestion?.Answer
              }, null, 8, _hoisted_24)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}